import React from "react";
import selctContact from "../assets/images/selctContact.svg";
import { useNavigate } from "react-router-dom";

export default function PhotoUploadSucc() {
  const navigate = useNavigate();
  const onClickUploaded = () => {
    navigate("/Signin");
  };
  return (
    <div className="mainPage loginPage">
      <div className="successful positioncenter">
        <div className="card  text-center">
          <div className="bluebox">
            <div className="circlemark">
              <img src={selctContact} />
            </div>
            <h5 className="text-white pt-4 mb-0">Uploaded</h5>
          </div>
          <div className="card-body">
            <p className="card-text">Photo Upload successfully.</p>

            <button
              type="button"
              onClick={onClickUploaded}
              className="btn btn-primary w-100 mt-3"
            >
              Ok
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
